import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/coordination";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	coordination: {
		id: "ktx.form.coordination",
		defaultMessage: "Koordinációs űrlap"
	},
	waitingListStartDate: {
		id: "ktx.form.coordination.start_date",
		defaultMessage: "ET várólistára kerülés ideje"
	},
	patientEtId: {
		id: "ktx.form.coordination.patient_et_id",
		defaultMessage: "ET azonosító"
	},
	patientEtIdPatternError: {
		id: "ktx.form.coordination.patient_et_id.error.pattern",
		defaultMessage:
			"Az azonosító csak számokat tartalmazhat és 6 karakter hosszú lehet."
	}
});

const fields: { [key: string]: FieldData } = {
	waitingListStartDate: {
		type: "field",
		path: ["waitingListStartDate"],
		label: messages.waitingListStartDate,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "date" } }
	},
	patientEtId: {
		type: "field",
		path: ["patientEtId"],
		label: messages.patientEtId,
		errorMessages: {
			...genericErrorMessages,
			pattern: messages.patientEtIdPatternError
		},
		input: { type: "input", props: { type: "text" } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.waitingListStartDate },
				{ width: 6, field: fields.patientEtId }
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_coordination",
	value: {
		schemaId: "coordination",
		title: messages.coordination,
		validator,
		fieldset,
		applyCurrentDate: true,
		defaults: [
			{
				path: ["patientEtId"],
				query: {
					interpretation: { vocab: "ktx", code: "patient_et_id" }
				}
			}
		]
	}
};
